const config = {
  baseURL:  process.env.NODE_ENV === 'development'?'http://localhost:5001':'https://api-driver.app.taxi.rio',
  baseURLBO: process.env.NODE_ENV === 'development'?'http://localhost:5002':'https://api-backoffice.app.taxi.rio',
};

export default config;
